// extracted by mini-css-extract-plugin
export default {"productsListGrid":"products-list_productsListGrid__29CLS"};